import  queryString from 'query-string'; 
//Utils done the proper way
export  default{
  checkLoggedIn: async function(){
    let qs = queryString.parse(location.search);
    let headers = {};
    if (qs.token){
      headers.Authorization = qs.token;
    }
    return fetch("/api/v1/logged-in",{headers:headers})
    .then(async response=>{
      if (response.ok){
        let result = await response.json();
        if (result.password_reset){
          let url = `/reset?u=${encodeURIComponent(result.email)}&t=${encodeURIComponent(result.token)}`;
          window.location = url;
          return false;
        } 
        return true;
      } else {
        window.location = "/login" + location.search; 
      }
    })
    .catch(error=>{
      console.error(error);
      window.location = "/login" + location.search; 
    })
  },

}